import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/ss';

export const stockApi = {
  // Get all sectors
  getSectors: async () => {
    const response = await axios.get(`${API_BASE_URL}/stocks/sectors`);
    return response.data;
  },

  // Get top stocks by sector
  getTopStocksBySector: async (sector, limit = 10) => {
    const response = await axios.get(`${API_BASE_URL}/stocks/top-by-sector`, {
      params: { sector, top_n: limit }
    });
    return response.data;
  },

  // Get sector performance
  getSectorPerformance: async (period = '1mo') => {
    const response = await axios.get(`${API_BASE_URL}/stocks/sector-performance`, {
      params: { period }
    });
    return response.data;
  },

  // Advanced stock screener
  screenStocks: async (filters) => {
    const response = await axios.get(`${API_BASE_URL}/stocks/screener`, {
      params: filters
    });
    return response.data;
  },

  // Get stock details
  getStockDetails: async (symbol) => {
    const response = await axios.get(`${API_BASE_URL}/stocks/${symbol}`);
    return response.data;
  }
};